module.exports = __webpack_public_path__ + "static/logistics-bdc1400a5880c39f0ba15c16530bc09e.jpg";